export default __webpack_public_path__ + "static/francisca-3b5dcf2ab50dff333ea642e0c399b9f6.jpg";